import $ from 'jquery';
import {updateLoginBoxNamesLhs} from '../commons/loginbox/name';
import {MARKET} from 'Utils/market.constants';

const initSupervision = function () {

    var dataUser = document.getElementById("sas_user_info");

    if(dataUser){
        var dataHtml = dataUser.innerHTML;
        var supervisionStatut = JSON.parse(dataHtml);

        var clientName = updateLoginBoxNamesLhs();
        var message;

        message = `Vous supervisez le client:  ${clientName}.`;
        $("#supervisionMessage").text(message);

        if(supervisionStatut["user-info-sup"] == 'true'){
            $("#supervision").show();
        }else{
            console.error("Impossible de récupérer l'information de supervision");
        }

        // pass the secure zone
        //$('#supervision div button').on('click', function(e) {
        $('#byPassButton').on('click', function(e) {
            e.preventDefault();
            $.ajax({
                url: "/sec/sup-clear-all-ZS.json",
                method: "GET",
                swmIntercept: false,
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: function (response) {
                    if(response.commun.statut === "ok"){
						/*// Avant :
                        if(MARKET.CODE === 1) {
                            window.location.href = "/icd/cbo/index-authsec.html#cbo/";
                        } else { // if(MARKET.CODE === 3)
                            //if(window.location.href === "/icd-web/syd-front/index-comptes.html#etape1")
                            window.location.href = "/icd-web/syd-front/index-comptes.html#comptes";
						}*/
						
						// TCOD-2948
						var newlocation = (MARKET.CODE === 1) ? "/icd/cbo/index-authsec.html#cbo/" : "/icd-web/syd-front/index-comptes.html#comptes" ;
						//Si l'on est déjà sur la page alors forcer le rafraîchissement
						if ( window.location.href.indexOf(newlocation)>=0) 
						    window.location.reload(true);
						else 
						    window.location.href = newlocation;						
                    }
                },
                error: function () {
                    console.log("Erreur ByPass zone de securité");
                }
            });
        });
		
		// On click close button : position fixed -> relative
		$('#Supervision_Close_Btn').on('click', function(e) {
			e.preventDefault();
			$('#supervision').addClass("dcw_Relative");
			// Hide itself
			$("#Supervision_Close_Btn").hide();
        });
	}
};

export {initSupervision};


// WEBPACK FOOTER //
// ./src/js/cms/commons/initSupervision.js